import React from 'react';
import PropTypes from 'prop-types';
import query from './query.graphql';
import DevTagCountTable from '../DevTagCountTable';

const CaregiverRelationshipCount = props => {
    return (
        <DevTagCountTable
            deploymentIds={props.filters.evalCycleSelectorField}
            query={query}
            devTag="WfiCaregiverRelationship"
            table={props.table}
            filters={props.filters}
            settings={props.settings}
            label="Caregiver Relationship"
        />
    );
};

CaregiverRelationshipCount.propTypes = {
    filters: PropTypes.object,
    table: PropTypes.object,
    settings: PropTypes.object,
};

export default CaregiverRelationshipCount;
